var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lecture",
    stroke: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,20.1001 C23.5,20.8731 22.855,21.5001 22.063,21.5001 L1.938,21.5001 C1.143,21.5001 0.5,20.8731 0.5,20.1001 L0.5,7.5001 L23.5,7.5001 L23.5,20.1001 L23.5,20.1001 Z",
    id: "Stroke-2529"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2530",
    strokeLinejoin: "round",
    points: "8.5 18.5 8.5 10.5 16.5 14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,5.5 L0.5,5.5 L0.5,1.5 C0.5,0.948 0.948,0.5 1.5,0.5 L22.5,0.5 C23.052,0.5 23.5,0.948 23.5,1.5 L23.5,5.5 L23.5,5.5 Z",
    id: "Stroke-2531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,5.001 L4.5,1.001",
    id: "Stroke-2532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4958,5.5044 L8.4998,0.5004",
    id: "Stroke-2533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4958,5.5044 L12.4998,0.5004",
    id: "Stroke-2534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4958,5.5044 L16.4998,0.5004",
    id: "Stroke-2535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5078,5.4927 L20.4998,0.5007",
    id: "Stroke-2536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,5.5005 L23.5,1.5005",
    id: "Stroke-2537"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.68feacbd425ecfb93fe4aec2303a18eb.svg";
export { ForwardRef as ReactComponent };